<template>
  <div class="product-info ">
    <div class="product-info-header">
      <div class="product-info-header-title">{{ itemInfo.input988275a1 }}</div>

    </div>
    <div class="product-info-content">
      <div style="margin: 15px 0;">
        <span style="cursor: pointer;" @click="close" class="product-info-content-back">详情中心&ensp;/&ensp; </span> <span
          style="color: rgba(32, 129, 235, 1);">详情页</span>
      </div>
      <div class="product-info-content-html" v-if="_html" v-html="_html"></div>

      <div class="product-info-content-page">
        <div class="product-info-content-page-button" @click="prevData">上一条 :
          <div class="product-info-content-page-button-text">{{ prev ? prev.input988275a1 : '无' }}</div>
        </div>
        <div class="product-info-content-page-button-right" @click="nextData">下一条 :
          <div class="product-info-content-page-button-text-right">{{ next ?
        next.input988275a1 : '无' }}</div>
        </div>
      </div>
    </div>
    <div class="product-info-footer">
      <a-button class="learnmore-btn" type="primary" @click="close">返回列表</a-button>
    </div>

  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { getFilterList, getRowById } from "@/api/index"

const props = defineProps({
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  list: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['changeItem', "close"])
const dataInfo = ref([])
const itemInfo = computed(() => props.itemInfo)
const list = computed(() => props.list)

const _html = computed(() => {
  return itemInfo.value["rich-editor20df22ce"] || ""
})

// const getData = async () => {
//  console.log(itemInfo.value);

//  if (itemInfo.value && itemInfo.value.rowId) {
//   let params = {
//    page: 1,
//    pageSize: 1000,
//    filters: [
//     {
//      "dataType": 65,
//      "field": "associationFields0d56121d",
//      "spliceType": 0,
//      "values": [
//       itemInfo.value.rowId
//      ],
//      "isDynamicSource": false,
//      "dynamicSource": [],
//      "filterType": 2
//     }

//    ],
//    worksheetId: "680f499f88d915058691fbd6",
//   }
//   const res = await getFilterList(params)
//   if (res.code === 200) {
//    dataInfo.value = res.data
//   }
//  }
// }

// watch(() => itemInfo.value, (newVal) => {
//  getData()
// }, { deep: true })

const prev = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) - 1]
})
const next = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) + 1]
})

const nextData = async () => {
  if (next.value) {
    // getFilter(next.value)
    emit("changeItem", next.value)
  }
}
const prevData = async () => {
  if (prev.value) {
    // getFilter(prev.value)
    emit("changeItem", prev.value)
  }
}

const close = () => {
  emit("close")
  handleScrollTop()
}
function step () {
  window.scrollTo({
    top: (0)
  })
}
function handleScrollTop () {
  window.requestAnimationFrame(step)
}

watch(() => itemInfo.value, () => {
  handleScrollTop()
}, { deep: true })

onMounted(() => {


  handleScrollTop()
})

</script>

<style scoped lang="less">
.product-info {
  font-family: 'PuHuiTi';
  width: 100%;
  height: 100%;
}

.product-info-header {
  width: 100%;
  height: 200px;
  background: url("../../../assets/image/product/itemInfo_bg.png") no-repeat;
  background-size: 100% 100%;
}

.product-info-header-title {
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  font-size: 32px;
  font-family: 'PuHuiTi';
  padding-left: 18%;
  padding-right: 18%;
  padding-top: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.product-info-content {
  width: 100%;
  height: 100%;
  padding-left: 18%;
  padding-right: 19%;
}

.product-info-content-img-bg {

  background: url("../../../assets/image/product/info_bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 30px;
  margin: 30px 0;
}

.product-info-content-title {
  font-size: 22px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  background: url("../../../assets/image/product/Line.png") no-repeat;
  background-position: 0% 100%;

}

.product-info-content-jianjie {
  font-size: 14px;
  margin-top: 20px;
  color: rgba(51, 51, 51, 1);
}

.product-info-footer {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
}

.learnmore-btn {

  width: 210px;
  height: 46px;
  margin-right: 1%;
  border-radius: 10px;
}

.product-info-content-page {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.product-info-content-page-button {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
}

.product-info-content-page-button-text {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-info-content-page-button-text-right {
  // width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.product-info-content-page-button-right {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  padding-left: 10px;
  display: flex;
  align-items: center;
  // justify-content: flex-end;
  cursor: pointer;
  padding-right: 10px;
}

.product-info-content-html {
  min-height: 519px;
}

::v-deep(.product-info-content-html img) {
  max-width: 100%;
}

.product-info-content-back:hover {
  color: rgba(32, 129, 235, 1);
}
</style>